import React, { FC } from 'react'
import { DetailsContactData } from '../types/detailsContactTypes'
import { FormattedMessage, useIntl } from 'react-intl'
import { makeStyles } from 'tss-react/mui'
import styles from '../../../styles'
import { Grid } from '@mui/material'
import { getDateFormat } from '../../../utils/formatter/formatDate'
import { DateFormat } from '../../../enums/dateFormatEnum'

interface InformationsDossierBailProps {
	informations: DetailsContactData
	typeContact: string
	isClientType: boolean
}

const InformationsDossierBail: FC<InformationsDossierBailProps> = (
	{
		informations,
		typeContact,
		isClientType
	}) => {
	const intl = useIntl()
	const { classes, cx } = useStyles()

	const descriptionStyle = cx(
		classes.text1
	)

	return (
		<Grid container item flexDirection="column">
			<Grid item className={descriptionStyle} marginBottom="10px">
				<FormattedMessage
					id={`detailsContact.informations.${typeContact}.subtitle`}
					defaultMessage="Son bail le plus récent est le bail suivant :"
					description="Son bail le plus récent est le bail suivant :"
				/>
			</Grid>
			<Grid item className={descriptionStyle}>
				<FormattedMessage
					id={`detailsContact.informations.${typeContact}.reference`}
					defaultMessage="Référence :"
					description="Référence :"
					values={{ reference: (isClientType ? informations.bail?.reference : informations.dossier?.name) || '' }}
				/>
			</Grid>
			<Grid item className={descriptionStyle}>
				<FormattedMessage
					id={`detailsContact.informations.${typeContact}.residence`}
					defaultMessage="Résidence  :"
					description="Résidence  :"
					values={{
						residence: isClientType ?
							!!informations.bail ? `${informations.bail?.codeImmeuble} / ${informations.bail?.nomImmeuble}` : ''
							:
							!!informations.residence ? `${informations.residence?.reference} / ${informations.residence?.nomCommercial}` : ''
					}}
				/>
			</Grid>
			<Grid item className={descriptionStyle}>
				<FormattedMessage
					id={`detailsContact.informations.${typeContact}.lot`}
					defaultMessage="Lot :"
					description="Lot :"
					values={{ reference: (isClientType ? informations.bail?.refLotPrincipal : informations.lot?.reference) || '' }}
				/>
			</Grid>
			{isClientType ?
				<Grid item className={descriptionStyle}>
					<FormattedMessage
						id={`detailsContact.informations.${typeContact}.dateEffet`}
						defaultMessage="Date d'effet :"
						description="Date d'effet :"
						values={{ date_effet: getDateFormat(informations.bail?.dateEffet, DateFormat.DD_MM_YYYY_SLASH) }}
					/>
				</Grid>
				:
				<Grid item className={descriptionStyle}>
					<FormattedMessage
						id={`detailsContact.informations.${typeContact}.date`}
						defaultMessage="Date à laquelle il a été initié :"
						description="Date à laquelle il a été initié :"
						values={{ createdon: getDateFormat(informations.dossier?.createdon, DateFormat.DD_MM_YYYY_SLASH) }}
					/>
				</Grid>
			}
			<Grid item className={descriptionStyle}>
				<FormattedMessage
					id={`detailsContact.informations.${typeContact}.statut`}
					defaultMessage="Statut :"
					description="Statut :"
					values={{
						statut: isClientType ?
							informations.bail?.phase || ''
							:
							!!informations.dossier?.status ? intl.formatMessage({ id: `detailsContact.dossier.status.${informations.dossier?.status}` }) : ''
					}}
				/>
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme)
}))

export default InformationsDossierBail